var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ProfileSelectionFromParams, SuffixParams } from '..';
import ProfileExplorerSingle from './ProfileExplorerSingle';
import ProfileExplorerCompare from './ProfileExplorerCompare';
import { useAppSelector, useAppDispatch, setCompare, selectCompareMode, setSearchNodeString, store, selectFilterByFunction, } from '@parca/store';
import { Provider, batch } from 'react-redux';
import { DateTimeRange } from '@parca/components';
import { useEffect } from 'react';
var getExpressionAsAString = function (expression) {
    var x = Array.isArray(expression) ? expression.join() : expression;
    return x;
};
/* eslint-disable @typescript-eslint/naming-convention */
var sanitizeDateRange = function (time_selection_a, from_a, to_a) {
    var range = DateTimeRange.fromRangeKey(time_selection_a);
    if (from_a == null && to_a == null) {
        from_a = range.getFromMs();
        to_a = range.getToMs();
    }
    return { time_selection_a: range.getRangeKey(), from_a: from_a, to_a: to_a };
};
/* eslint-enable @typescript-eslint/naming-convention */
var filterSuffix = function (o, suffix) {
    return Object.fromEntries(Object.entries(o).filter(function (_a) {
        var key = _a[0];
        return !key.endsWith(suffix);
    }));
};
var swapQueryParameters = function (o) {
    Object.entries(o).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (key.endsWith('_b')) {
            o[key.slice(0, -2) + '_a'] = value;
        }
    });
    return o;
};
var ProfileExplorerApp = function (_a) {
    var _b, _c;
    var queryClient = _a.queryClient, queryParams = _a.queryParams, navigateTo = _a.navigateTo;
    var dispatch = useAppDispatch();
    var compareMode = useAppSelector(selectCompareMode);
    /* eslint-disable @typescript-eslint/naming-convention */
    var from_a = queryParams.from_a, to_a = queryParams.to_a, merge_a = queryParams.merge_a, profile_name_a = queryParams.profile_name_a, labels_a = queryParams.labels_a, time_a = queryParams.time_a, time_selection_a = queryParams.time_selection_a, compare_a = queryParams.compare_a, from_b = queryParams.from_b, to_b = queryParams.to_b, merge_b = queryParams.merge_b, profile_name_b = queryParams.profile_name_b, labels_b = queryParams.labels_b, time_b = queryParams.time_b, time_selection_b = queryParams.time_selection_b, compare_b = queryParams.compare_b;
    /* eslint-enable @typescript-eslint/naming-convention */
    var filterByFunction = useAppSelector(selectFilterByFunction);
    var sanitizedRange = sanitizeDateRange(time_selection_a, from_a, to_a);
    time_selection_a = sanitizedRange.time_selection_a;
    from_a = sanitizedRange.from_a;
    to_a = sanitizedRange.to_a;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var expression_a = getExpressionAsAString(queryParams.expression_a);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var expression_b = getExpressionAsAString(queryParams.expression_b);
    if (((_b = queryParams === null || queryParams === void 0 ? void 0 : queryParams.expression_a) !== null && _b !== void 0 ? _b : '') !== '')
        queryParams.expression_a = expression_a;
    if (((_c = queryParams === null || queryParams === void 0 ? void 0 : queryParams.expression_b) !== null && _c !== void 0 ? _c : '') !== '')
        queryParams.expression_b = expression_b;
    useEffect(function () {
        if (compare_a === 'true' && compare_b === 'true') {
            dispatch(setCompare(true));
        }
        else {
            dispatch(setCompare(false));
        }
    }, [dispatch, compare_a, compare_b]);
    var selectProfile = function (p, suffix) {
        queryParams.expression_a = encodeURIComponent(queryParams.expression_a);
        queryParams.expression_b = encodeURIComponent(queryParams.expression_b);
        return navigateTo('/', __assign(__assign({}, queryParams), SuffixParams(p.HistoryParams(), suffix)));
    };
    var selectProfileA = function (p) {
        return selectProfile(p, '_a');
    };
    var selectProfileB = function (p) {
        return selectProfile(p, '_b');
    };
    // Show the SingleProfileExplorer when not comparing
    if (compare_a !== 'true' && compare_b !== 'true') {
        var query_1 = {
            expression: expression_a,
            from: parseInt(from_a),
            to: parseInt(to_a),
            merge: merge_a === 'true',
            profile_name: profile_name_a,
            timeSelection: time_selection_a,
        };
        var profile_1 = ProfileSelectionFromParams(expression_a, from_a, to_a, merge_a, labels_a, profile_name_a, time_a, filterByFunction);
        var selectQuery = function (q) {
            return navigateTo('/', __assign(__assign({}, filterSuffix(queryParams, '_a')), {
                expression_a: encodeURIComponent(q.expression),
                from_a: q.from.toString(),
                to_a: q.to.toString(),
                merge_a: q.merge,
                time_selection_a: q.timeSelection,
                currentProfileView: 'icicle',
            }));
        };
        var selectProfile_1 = function (p) {
            queryParams.expression_a = encodeURIComponent(queryParams.expression_a);
            return navigateTo('/', __assign(__assign({}, queryParams), SuffixParams(p.HistoryParams(), '_a')));
        };
        var compareProfile = function () {
            var compareQuery = {
                compare_a: 'true',
                expression_a: encodeURIComponent(query_1.expression),
                from_a: query_1.from.toString(),
                to_a: query_1.to.toString(),
                merge_a: query_1.merge,
                time_selection_a: query_1.timeSelection,
                profile_name_a: query_1.profile_name,
                compare_b: 'true',
                expression_b: encodeURIComponent(query_1.expression),
                from_b: query_1.from.toString(),
                to_b: query_1.to.toString(),
                merge_b: query_1.merge,
                time_selection_b: query_1.timeSelection,
                profile_name_b: query_1.profile_name,
            };
            if (profile_1 != null) {
                compareQuery = __assign(__assign({}, SuffixParams(profile_1.HistoryParams(), '_a')), compareQuery);
            }
            compareQuery = __assign(__assign({}, compareQuery), {
                currentProfileView: 'icicle',
            });
            batch(function () {
                dispatch(setCompare(!compareMode));
                dispatch(setSearchNodeString(undefined));
            });
            void navigateTo('/', compareQuery);
        };
        return (_jsx(ProfileExplorerSingle, { queryClient: queryClient, query: query_1, profile: profile_1, selectQuery: selectQuery, selectProfile: selectProfile_1, compareProfile: compareProfile, navigateTo: navigateTo }));
    }
    var queryA = {
        expression: expression_a,
        from: parseInt(from_a),
        to: parseInt(to_a),
        merge: merge_a === 'true',
        timeSelection: time_selection_a,
        profile_name: profile_name_a,
    };
    var queryB = {
        expression: expression_b,
        from: parseInt(from_b),
        to: parseInt(to_b),
        merge: merge_b === 'true',
        timeSelection: time_selection_b,
        profile_name: profile_name_b,
    };
    var profileA = ProfileSelectionFromParams(expression_a, from_a, to_a, merge_a, labels_a, profile_name_a, time_a);
    var profileB = ProfileSelectionFromParams(expression_b, from_b, to_b, merge_b, labels_b, profile_name_b, time_b);
    var selectQueryA = function (q) {
        return navigateTo('/', __assign(__assign({}, filterSuffix(queryParams, '_a')), {
            compare_a: 'true',
            expression_a: encodeURIComponent(q.expression),
            expression_b: encodeURIComponent(expression_b),
            from_a: q.from.toString(),
            to_a: q.to.toString(),
            merge_a: q.merge,
            time_selection_a: q.timeSelection,
            filterByFunction: filterByFunction,
        }));
    };
    var selectQueryB = function (q) {
        return navigateTo('/', __assign(__assign({}, filterSuffix(queryParams, '_b')), {
            compare_b: 'true',
            expression_b: encodeURIComponent(q.expression),
            expression_a: encodeURIComponent(expression_a),
            from_b: q.from.toString(),
            to_b: q.to.toString(),
            merge_b: q.merge,
            time_selection_b: q.timeSelection,
            filterByFunction: filterByFunction,
        }));
    };
    var closeProfile = function (card) {
        var newQueryParameters = queryParams;
        if (card === 'A') {
            newQueryParameters = swapQueryParameters(queryParams);
        }
        batch(function () {
            dispatch(setCompare(!compareMode));
            dispatch(setSearchNodeString(undefined));
        });
        return navigateTo('/', __assign(__assign({}, filterSuffix(newQueryParameters, '_b')), {
            compare_a: 'false',
        }));
    };
    return (_jsx(ProfileExplorerCompare, { queryClient: queryClient, queryA: queryA, queryB: queryB, profileA: profileA, profileB: profileB, selectQueryA: selectQueryA, selectQueryB: selectQueryB, selectProfileA: selectProfileA, selectProfileB: selectProfileB, closeProfile: closeProfile, navigateTo: navigateTo }));
};
var ProfileExplorer = function (_a) {
    var queryClient = _a.queryClient, queryParams = _a.queryParams, navigateTo = _a.navigateTo;
    var reduxStore = store().store;
    return (_jsx(Provider, __assign({ store: reduxStore }, { children: _jsx(ProfileExplorerApp, { queryClient: queryClient, queryParams: queryParams, navigateTo: navigateTo }) })));
};
export default ProfileExplorer;
